module.exports = __webpack_public_path__ + "static/img/person.9c13564f.svg";